function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import React, { PureComponent, Fragment } from 'react';
import { debounce } from 'debounce';
import PropTypes from 'prop-types';
import { getIsTopComponentVisible } from "./utils/getIsTopComponentVisible";
import { getIsBottomComponentVisible } from "./utils/getIsBottomComponentVisible";
import { getComponentPosition } from "./utils/getComponentPosition";
export var Component = function (_PureComponent) {
  _inherits(Component, _PureComponent);

  var _super = _createSuper(Component);

  function Component() {
    var _this;

    _classCallCheck(this, Component);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _defineProperty(_assertThisInitialized(_this), "state", {
      shouldRender: false
    });

    _defineProperty(_assertThisInitialized(_this), "componentDidMount", function () {
      _this.addEventListeners();

      _this.getShouldComponentRender();
    });

    _defineProperty(_assertThisInitialized(_this), "componentWillUnmount", function () {
      return _this.removeEventListeners();
    });

    _defineProperty(_assertThisInitialized(_this), "getShouldComponentRender", function () {
      var topComponentPosition = getComponentPosition(_this.topComponent);
      var bottomComponentPosition = getComponentPosition(_this.bottomComponent);
      if (!topComponentPosition || !bottomComponentPosition) return;
      var windowHeight = window.innerHeight;
      var isTopComponentVisible = getIsTopComponentVisible(topComponentPosition, windowHeight);
      var isBottomComponentVisible = getIsBottomComponentVisible(bottomComponentPosition, windowHeight);

      if (isTopComponentVisible || isBottomComponentVisible) {
        _this.setState({
          shouldRender: true
        });

        _this.removeEventListeners();
      }
    });

    _defineProperty(_assertThisInitialized(_this), "debouncedGetShouldComponentRender", debounce(_this.getShouldComponentRender, 10));

    _defineProperty(_assertThisInitialized(_this), "addEventListeners", function () {
      global.window.addEventListener('scroll', _this.debouncedGetShouldComponentRender, true);
      global.window.addEventListener('resize', _this.debouncedGetShouldComponentRender, true);
    });

    _defineProperty(_assertThisInitialized(_this), "removeEventListeners", function () {
      global.window.removeEventListener('scroll', _this.debouncedGetShouldComponentRender, true);
      global.window.removeEventListener('resize', _this.debouncedGetShouldComponentRender, true);
    });

    _defineProperty(_assertThisInitialized(_this), "createTopComponentRef", function (component) {
      return _this.topComponent = component;
    });

    _defineProperty(_assertThisInitialized(_this), "createBottomComponentRef", function (component) {
      return _this.bottomComponent = component;
    });

    _defineProperty(_assertThisInitialized(_this), "render", function () {
      var _this$props = _this.props,
          children = _this$props.children,
          lazyProps = _this$props.lazyProps,
          componentProps = _this$props.componentProps;
      return React.createElement(Fragment, null, React.createElement("div", {
        ref: _this.createTopComponentRef
      }), React.cloneElement(children, _objectSpread(_objectSpread({}, componentProps), _this.state.shouldRender ? lazyProps : {})), React.createElement("div", {
        ref: _this.createBottomComponentRef
      }));
    });

    return _this;
  }

  return Component;
}(PureComponent);
Component.displayName = 'LazyLoader';
Component.defaultProps = {
  componentProps: undefined,
  lazyProps: undefined
};
Component.propTypes = process.env.NODE_ENV !== "production" ? {
  children: PropTypes.node.isRequired,
  componentProps: PropTypes.object,
  lazyProps: PropTypes.object
} : {};